<script setup lang="ts">
import { defineOptions, defineEmits, defineProps, computed } from "vue";
import LoadingComponent from "./LoadingComponent.vue";

defineOptions({ name: "GenericButton" });

const props = defineProps({
  text: { type: String, required: false },
  class: { type: String, required: false },
  loading: { type: Boolean, required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  variant: { type: String, required: false, default: "primary" },
});

const emit = defineEmits(["click"]);

const classByVariant = computed(() => {
  const disabledClass =
    props.disabled || props.loading
      ? "opacity-50 cursor-not-allowed! "
      : "cursor-pointer ";
  switch (props.variant) {
    case "primary":
      return (
        disabledClass +
        "bg-gradient-to-r from-primary-400 to-primary-900 text-white p-4 rounded-full"
      );
    case "secondary":
      return (
        disabledClass +
        "bg-primary-100 text-primary-900 p-4 rounded-full hover:bg-primary-200"
      );
    case "outline":
      return (
        disabledClass +
        "border border-primary-500 text-primary-500 p-4 rounded-full hover:bg-primary-50"
      );
    case "ghost":
      return (
        disabledClass + "text-primary-500 p-4 rounded-full hover:bg-primary-50"
      );
    case "error":
      return disabledClass + "bg-error text-white p-4 rounded-full";
    default:
      return (
        disabledClass +
        "bg-gradient-to-r from-primary-400 to-primary-900 text-white p-4 rounded-full"
      );
  }
});
</script>

<template>
  <button
    :class="classByVariant + ' ' + props.class"
    :disabled="props.disabled || props.loading"
    @click="emit('click')"
  >
    <LoadingComponent v-if="props.loading" />
    <span v-else-if="props.text">{{ props.text }}</span>
    <slot v-else />
  </button>
</template>
